module.exports = __webpack_public_path__ + "img/icon_dining.904e3a29.png";